'use client';

import { useDroppable } from '@dnd-kit/core';
import { FC } from 'react';
import { DroppableZoneProps } from './DroppableZone.types';
import styles from './DroppableZone.module.css';
import { getClasses } from '@/_utils/classnames';

export const DroppableZone: FC<DroppableZoneProps> = ({
  children,
  id,
  isDropDisabled = false,
  className,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id,
    disabled: isDropDisabled,
  });

  const droppableZoneClasses: string = getClasses(className, {
    [styles.droppableZone]: isOver,
  });

  return (
    <div ref={setNodeRef} className={droppableZoneClasses}>
      {children}
    </div>
  );
};
